import React from 'react';

import { Box } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { BigDot, BigDotOrangeWithOutline, CheckCircularGreenDualTone } from 'assets/assetsV1/iconComponents';

import { StringModifier, modifyString } from 'constants/copyHelpers';
import { findAndReplaceString } from 'constants/helper';

import { ListItemComp } from 'uiToolkitV1/ListItemComp';

const BottomConnector = ({ withMargin = false }) => (
  <Box w="2px" bg="border.CFD7DF" position="absolute" h="15px" left="23px" bottom={withMargin ? '-7px' : '-1px'} />
);
const TopConnector = ({ withMargin = false }) => (
  <Box w="2px" bg="border.CFD7DF" position="absolute" h="15px" left="23px" top={withMargin ? '-7px' : '0px'} />
);
const FormTabToggle = ({
  options = [],
  selectedOptionId = options?.[0]?.id,
  changeHandler = () => {},
  isRedCurrentStepStyle = false,
  withMargin = false,
  ...containerProps
}) => {
  // const [selectedOptionValue, setSelectedOptionValue] = useState(selectedOptionId);
  const { moduleName } = useOrganisationSettings();

  const onChangeHandler = (newSelectedValue) => {
    // setSelectedOptionValue(newSelectedValue);
    changeHandler(newSelectedValue);
  };

  return (
    <Box {...containerProps}>
      {options?.map(({ id, title, subTitle, isComplete, isDisabled = false, hasError }, index) => {
        const isSelected = selectedOptionId === id;
        return (
          <Box pos="relative" mb={withMargin ? 3 : 0}>
            <ListItemComp
              isDisabled={isDisabled}
              active={isSelected}
              key={id}
              onClick={() => !isDisabled && onChangeHandler(id)}
              title={findAndReplaceString(title, modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE), 'Goals')}
              subTitle={subTitle}
              LeftComponent={
                isSelected && isRedCurrentStepStyle
                  ? () => <BigDotOrangeWithOutline boxSize="24px" />
                  : isComplete
                    ? () => <CheckCircularGreenDualTone boxSize="24px" />
                    : () => <BigDot boxSize="24px" color="#999 !important" />
              }
              isBoldText={isSelected}
              padding="4px 12px"
              minHeight="44px"
            />
            {index > 0 && <TopConnector withMargin={withMargin} />}
            {index < options.length - 1 && <BottomConnector withMargin={withMargin} />}
          </Box>
        );
      })}
    </Box>
  );
};
export { FormTabToggle };
